/* Adds approved species examples to this product's gallery and detail modules. */
(() => {
  'use strict';
  const configNode = document.getElementById('lm-parrot-species-preview');
  const productNode = document.querySelector('[data-product-handle="flexible-textured-parrot-perch"] [data-product-json]');
  if (!configNode || !productNode) return;
  let config, product;
  try {
    config = JSON.parse(configNode.textContent);
    product = JSON.parse(productNode.textContent);
  } catch (_) { return; }
  const set = product.image_experiment_gallery_sets?.sets?.parrot_instincts_gallery_v1;
  const version = product.pdp_versions?.versions?.parrot_instincts_v1;
  if (!set || !Array.isArray(set.images) || set.images.length !== 6 || !Array.isArray(version?.gallery) || version.gallery.length !== 5 || !Array.isArray(version.details)) return;
  if (!config.image_url?.startsWith('https://cdn.shopify.com/s/files/')) return;
  const original = set.images;
  // Existing detail sections use numbered media positions. Preserve the actual
  // image they reference when the new second image shifts later positions.
  const detailReferences = [];
  for (const details of Object.values(product.pdp_versions.versions).map(v => v?.details).filter(Array.isArray)) {
    for (const item of details) {
      if (!Number.isInteger(item.image_position)) continue;
      const media = original.find(image => image.position === item.image_position);
      if (!media?.media_key) return; // Leave the entire original page intact.
      detailReferences.push([item, media.media_key]);
    }
  }
  detailReferences.forEach(([item, key]) => { item.media_key = key; delete item.image_position; });
  const added = {
    position: 2, role: 'compatibility', media_key: 'parrot_species_examples',
    image_url: config.image_url,
    alt_text: 'Common small and medium parrot examples: Budgies, Cockatiels, Lovebirds, Pacific Parrotlets, Green-Cheeked Conures, Sun Conures, Quaker Parrots and Caiques.'
  };
  set.images = [original[0], added, ...original.slice(1)].map((image, index) => ({ ...image, position: index + 1 }));
  version.gallery = [{
    role: 'compatibility', buyer_question: 'Which common small and medium parrots does this refer to?',
    message: 'For Small & Medium Parrots — Common examples',
    visual_direction: 'Eight bird portraits with names; illustrative examples, not product-use photographs.'
  }, ...version.gallery];
  const firstFaq = version.details.findIndex(item => item.kind === 'faq');
  version.details.splice(firstFaq < 0 ? version.details.length : firstFaq, 0, {
    kind: 'fit_and_size', presentation: 'image_only',
    buyer_question: 'Which common small and medium parrots does this refer to?',
    headline: 'For Small & Medium Parrots',
    body: 'Common examples: Budgies, Cockatiels, Lovebirds, Pacific Parrotlets, Green-Cheeked Conures, Sun Conures, Quaker Parrots and Caiques.',
    media_key: 'parrot_species_examples', visual_direction: 'parrot_species_examples'
  });
  productNode.textContent = JSON.stringify(product);
})();
